import React, { createContext, useContext, useState, useEffect } from 'react';
import WebSocketManager from './WebSocketManager';
import { useAuth } from 'oidc-react';

const WebSocketContext = createContext(null);

export const useWebSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const [socketData, setSocketData] = useState(null);
  const {userData} = useAuth()
  console.log(userData?.profile,"authData1221")

  useEffect(() => {
    const userId = userData?.profile?.sub
    const token = sessionStorage.getItem('jwt_access_token');

    if (userId && token) {
      WebSocketManager.setCredentials(userId, token);

      const handleData = (data) => {
        setSocketData(data);
      };

      WebSocketManager.addListener(handleData);

      return () => {
        WebSocketManager.removeListener(handleData);
      };
    } else {
      console.error('User ID and token must be set in local storage');
    }
  }, [userData]);

  return (
    <WebSocketContext.Provider value={socketData}>
      {children}
    </WebSocketContext.Provider>
  );
};
